import { createContext } from 'react';

export const WebSocketContext = createContext({
  isConnected: false,
  setIsConnected: (value: boolean) => {},
});